import { Action, createReducer, on } from '@ngrx/store';
import { IAVCFrequencyLookup, PFSetting } from '../models/pf-settings.model';
import * as actions from '../actions';

export const getPFSettingsFeatureKey = 'getPFSettings';
export interface PFSettingsState {
  loadPFSettingsResponse: PFSetting[];
  loadPFSettingsResponseFailure: any;
  loaded: boolean;
}

export const initialState: PFSettingsState = {
  loadPFSettingsResponse: undefined,
  loadPFSettingsResponseFailure: undefined,
  loaded: false
};

export const reducer = createReducer(
  initialState,
  on(actions.loadPFSettings, (state, action) => ({
    ...state
  })),
  on(actions.loadPFSettingsSuccess, (state, action) => ({
    ...state,
    loadPFSettingsResponse: action.response,
    loaded: true
  })),
  on(actions.loadPFSettingsFailure, (state, action) => ({
    ...state,
    loadPFSettingsResponseFailure: action.error
  })),
  on(actions.loadClearPFSettings, (state, action) => ({
    ...state,
    loadPFSettingsResponse: undefined,
    loaded: false
  }))
);

export const getPFSettingsResponse = (state: PFSettingsState) => {
  if (state && state.loadPFSettingsResponse) return JSON.parse(JSON.stringify(state.loadPFSettingsResponse));
  else return null;
};

export const getPFSettingsIsLoaded = (state: PFSettingsState) => {
  state.loaded;
};
